module.exports = __webpack_public_path__ + "static/media/contact_form_image.0cc6cbc7.png";